<template>
    <div class="chargeBox">
        <div class="title">
            <p></p>
            <h4>收款二维码列表</h4>
        </div>
        <avue-crud :data="data" :option="option" >
            <template slot="menu" slot-scope="scope" >
                <a :href="scope.row.all_url" target="_blank" style="color: #ffffff"><el-button type="primary">查看文件</el-button></a>
            </template>
        </avue-crud>
        <div class="title" style="margin-top: 40px">
            <p></p>
            <h4>收款银行账号信息</h4>
        </div>
        <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="开户名">
                <el-input v-model="form.kaihu_name"></el-input>
            </el-form-item>
            <el-form-item label="开户行">
                <el-input v-model="form.kaihu_hang"></el-input>
            </el-form-item>
            <el-form-item label="开户账号">
                <el-input v-model="form.kaihu_zhhao"></el-input>
            </el-form-item>
            <el-form-item label="行号">
                <el-input v-model="form.hang_hao"></el-input>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import { chargeInformation } from '../../../api/insure';

    export default {
        name: 'chargeDetail',
        data() {
            return {
                form:{
                    kaihu_name:'',
                    kaihu_hang:'',
                    kaihu_zhhao:'',
                    hang_hao:'',
                },
                data: [],
                option:{
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:240,  //操作栏宽度设置
                    column:[
                        {
                            label:'文件名称',
                            prop:'name'
                        }, {
                            label:'创建时间',
                            prop:'add_time'
                        }
                    ]
                },
            };
        },
        created() {
            chargeInformation({case_id:this.$route.query.id}).then(res=>{
                if (res.code==200){
                    this.data=res.data.shoukuan
                    this.form=res.data.bank_arr
                }else {
                    this.$message.error(res.msg)
                }
            })
        }
    };
</script>

<style scoped>
    .chargeBox{
        padding: 30px;
        background-color: #ffffff;
        border-radius: 5px;
    }
    .title{
        display: flex;
        align-items: center;
        color: #3e62f6;
    }
    .title>p{
        width: 5px;
        height: 18px;
        background-color: #3b63f6;
        margin-right: 10px;
    }
    /deep/.el-input{
        width: 30%;
    }
    /deep/.el-form{
        margin-top: 30px;
    }
</style>
